import type { CustomFormAnswerEntry, CustomFormAnswerMap, CustomFormField } from "./types";

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function buildAnswerEntries(fields: CustomFormField[], values: CustomFormAnswerMap): CustomFormAnswerEntry[] {
  return fields.map((field) => ({ fieldUUID: field.uuid, value: values[field.uuid] ?? null }));
}

export function validateRequired(fields: CustomFormField[], values: CustomFormAnswerMap): Record<string, string> {
  const errors: Record<string, string> = {};
  fields.forEach((field) => {
    if (!field.required) return;
    const value = values[field.uuid];
    const isEmpty =
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);
    if (isEmpty) errors[field.uuid] = `${field.label} is required`;
  });
  return errors;
}

